module.exports = __webpack_public_path__ + "img/5A492B_DEC583_987D4D_AC9C74-256px.dc6cdddd.png";